import React from 'react';

export default function Loader() {
    return (
        <div className="z-40 p-2  absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ">
            <div className="w-16 h-16 border-4 border-blue-400 border-solid border-t-0 border-l-0 rounded-full animate-spin" />
        </div>
    );
}
